import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, PopoverController, ViewController } from 'ionic-angular'

@IonicPage()
@Component({
  selector: 'page-colors-popover',
  templateUrl: 'colors-popover.html',
})
export class ColorsPopoverPage {

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public popoverController: PopoverController,
    public viewController: ViewController) {
  }

  changeBackground (color) {
    this.viewController.dismiss(color)
  }

}



// WEBPACK FOOTER //
// ./src/pages/colors-popover/colors-popover.ts